import { render, staticRenderFns } from "./AddChannelStage1.vue?vue&type=template&id=1864bc88&scoped=true"
import script from "./AddChannelStage1.vue?vue&type=script&lang=js"
export * from "./AddChannelStage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864bc88",
  null
  
)

export default component.exports